
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"3 3 18 18","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{attrs:{"d":"M8.836 13.216h4.061M8.223 10.146h7.555"}})]),_c('g',{attrs:{"stroke-width":"1.25"}},[_c('path',{attrs:{"d":"M20.5 11.318c0 4.287-3.824 7.728-8.5 7.728-.606 0-1.195-.06-1.766-.17M6.899 17.49C4.841 16.083 3.5 13.852 3.5 11.318M6.899 17.49v3.037"}}),_c('path',{attrs:{"d":"M3.5 11.318c0-4.287 3.823-7.726 8.5-7.726s8.5 3.44 8.5 7.727M10.234 18.873L6.9 20.526"}})])])
          )
        }
      }
    